<section class="dynamic-collapse">
	<section class="dynamic-collapse-header">
		<div class="data-info">
			<h3>{{title}}</h3>
			<h2><span>{{total | currency:'GBP':'symbol-narrow':'1.0'}}</span></h2>
		</div>
	</section>
	<section class="dynamic-collapse-main">
		<div class="dynamic-collapse-content">
			<div class="items-data-info" *ngFor="let item of items">
				<div class="item-name">{{item.itemName}}</div>
				<div class="total-count" *ngIf="item.itemTotal>=0">
					{{item.itemTotal | currency:'GBP':'symbol-narrow':'1.0'}}</div>
				<div class="total-count" *ngIf="item.itemTotal<0" style="color:red">
					({{item.itemTotal * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
				</div>
			</div>
		</div>
	</section>
</section>
